// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/TCCC-UnityHeadline-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/TCCC-UnityHeadline-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/TCCC-UnityHeadline-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/TCCC-UnityHeadline-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/TCCC-UnityHeadline-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/TCCC-UnityText-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/TCCC-UnityText-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/TCCC-UnityText-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/TCCC-UnityText-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/TCCC-UnityText-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/TCCC-UnityText-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/Mairo.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/OoohBaby-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TCCC-UnityHeadline */
/* black: 800 */
@font-face {
  font-weight: 800;
  font-family: TCCC-UnityHeadline;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
}
/* bold: 700 */
@font-face {
  font-weight: 700;
  font-family: TCCC-UnityHeadline;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
}
/* medium: 600 */
@font-face {
  font-weight: 600;
  font-family: TCCC-UnityHeadline;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
}
/* regular: 400 */
@font-face {
  font-weight: 400;
  font-family: TCCC-UnityHeadline;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2');
}
/* light: 300 */
@font-face {
  font-weight: 300;
  font-family: TCCC-UnityHeadline;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2');
}

/* TCCC-UnityText */
/* black: 800 */
@font-face {
  font-weight: 800;
  font-family: TCCC-UnityText;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff2');
}

/* bold: 700 */
@font-face {
  font-weight: 700;
  font-family: TCCC-UnityText;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2');
}
/* bold italic: 700 */
@font-face {
  font-weight: 700;
  font-family: TCCC-UnityText;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff2');
}
/* medium: 600 */
@font-face {
  font-weight: 600;
  font-family: TCCC-UnityText;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2');
}
/* regular: 400 */
@font-face {
  font-weight: 400;
  font-family: TCCC-UnityText;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff2');
}
/* light: 300 */
@font-face {
  font-weight: 300;
  font-family: TCCC-UnityText;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2');
}

/* MAIRO */
@font-face {
  font-weight: 400;
  font-family: Mairo;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('opentype');
}

/* OOOH BABY */
@font-face {
  font-weight: 400;
  font-family: OoohBaby;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('truetype');
}`, "",{"version":3,"sources":["webpack://./src/assets/css/typography.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB,eAAe;AACf;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,4DAAmE;AACrE;AACA,cAAc;AACd;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,4DAAkE;AACpE;AACA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,4DAAoE;AACtE;AACA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,4DAAqE;AACvE;AACA,eAAe;AACf;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,4DAAmE;AACrE;;AAEA,mBAAmB;AACnB,eAAe;AACf;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,4DAA+D;AACjE;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,4DAA8D;AAChE;AACA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,4DAAoE;AACtE;AACA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,4DAAgE;AAClE;AACA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,4DAAiE;AACnE;AACA,eAAe;AACf;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,6DAA+D;AACjE;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gEAAiD;AACnD;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gEAA4D;AAC9D","sourcesContent":["/* TCCC-UnityHeadline */\n/* black: 800 */\n@font-face {\n  font-weight: 800;\n  font-family: TCCC-UnityHeadline;\n  src: url('../fonts/TCCC-UnityHeadline-Black.woff2') format('woff2');\n}\n/* bold: 700 */\n@font-face {\n  font-weight: 700;\n  font-family: TCCC-UnityHeadline;\n  src: url('../fonts/TCCC-UnityHeadline-Bold.woff2') format('woff2');\n}\n/* medium: 600 */\n@font-face {\n  font-weight: 600;\n  font-family: TCCC-UnityHeadline;\n  src: url('../fonts/TCCC-UnityHeadline-Medium.woff2') format('woff2');\n}\n/* regular: 400 */\n@font-face {\n  font-weight: 400;\n  font-family: TCCC-UnityHeadline;\n  src: url('../fonts/TCCC-UnityHeadline-Regular.woff2') format('woff2');\n}\n/* light: 300 */\n@font-face {\n  font-weight: 300;\n  font-family: TCCC-UnityHeadline;\n  src: url('../fonts/TCCC-UnityHeadline-Light.woff2') format('woff2');\n}\n\n/* TCCC-UnityText */\n/* black: 800 */\n@font-face {\n  font-weight: 800;\n  font-family: TCCC-UnityText;\n  src: url('../fonts/TCCC-UnityText-Black.woff2') format('woff2');\n}\n\n/* bold: 700 */\n@font-face {\n  font-weight: 700;\n  font-family: TCCC-UnityText;\n  src: url('../fonts/TCCC-UnityText-Bold.woff2') format('woff2');\n}\n/* bold italic: 700 */\n@font-face {\n  font-weight: 700;\n  font-family: TCCC-UnityText;\n  font-style: italic;\n  src: url('../fonts/TCCC-UnityText-BoldItalic.woff2') format('woff2');\n}\n/* medium: 600 */\n@font-face {\n  font-weight: 600;\n  font-family: TCCC-UnityText;\n  src: url('../fonts/TCCC-UnityText-Medium.woff2') format('woff2');\n}\n/* regular: 400 */\n@font-face {\n  font-weight: 400;\n  font-family: TCCC-UnityText;\n  src: url('../fonts/TCCC-UnityText-Regular.woff2') format('woff2');\n}\n/* light: 300 */\n@font-face {\n  font-weight: 300;\n  font-family: TCCC-UnityText;\n  src: url('../fonts/TCCC-UnityText-Light.woff2') format('woff2');\n}\n\n/* MAIRO */\n@font-face {\n  font-weight: 400;\n  font-family: Mairo;\n  src: url('../fonts/Mairo.otf') format('opentype');\n}\n\n/* OOOH BABY */\n@font-face {\n  font-weight: 400;\n  font-family: OoohBaby;\n  src: url('../fonts/OoohBaby-Regular.ttf') format('truetype');\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
